<template>
    <div class="pages_content table">
        <el-container>
            <el-header>
                <breaDcrumb />
            </el-header>
            <el-main style="display: flex">
                <div>
                    <el-collapse-transition>
                        <div v-show="showCardNav">
                            <div class="search">
                                <span style="display: inline-block; margin-bottom: 10px">
                                    <span style="margin-right: 12px">时间</span>
                                    <el-date-picker v-model="tableParam.dataMouth" style="width: 100px;" type="month"
                                        unlink-panels value-format="yyyy-MM" start-placeholder="开始时间"
                                        end-placeholder="结束时间"></el-date-picker>
                                </span>
                                <span style="display: inline-block; margin-left: 12px">
                                    <span style="margin-right: 12px">工程名称</span>
                                    <el-input v-model="tableParam.engineeringName"
                                        style="width: 180px; min-width: 150px; max-width: 220px" clearable placeholder="请输入"
                                        @keyup.enter.native="gettableData()" />
                                </span>
                                <span style="display: inline-block; margin-left: 12px">
                                    <span style="margin-right: 12px">销售员</span>
                                    <el-input v-model="tableParam.saller"
                                        style="width: 100px; min-width: 100px; max-width: 120px" clearable placeholder="请输入"
                                        @keyup.enter.native="gettableData()" />
                                </span>
                                <span style="display: inline-block; margin-left: 12px">
                                    <span style="margin-right: 12px">欠款管控等级</span>
                                    <el-select v-model="tableParam.debtControlLevelList" style="width: 150px" multiple
                                        clearable>
                                        <el-option label="不管控" :value="0"></el-option>
                                        <el-option label="等级一" :value="1"></el-option>
                                        <el-option label="等级二" :value="2"></el-option>
                                        <el-option label="等级三" :value="3"></el-option>
                                        <el-option label="等级四" :value="4"></el-option>
                                    </el-select>
                                </span>
                                <span style="display: inline-block; margin-left: 12px">
                                    <span style="margin-right: 12px">状态</span>
                                    <el-select v-model="tableParam.controlTypeList" style="width: 150px" multiple clearable>
                                        <el-option label="已解控" :value="0"></el-option>
                                        <el-option label="已风控" :value="1"></el-option>
                                        <el-option label="临时解控" :value="2"></el-option>
                                    </el-select>
                                </span>
                                <span style="display: inline-block; margin-left: 12px">
                                    <span style="margin-right: 12px">审批状态</span>
                                    <el-select v-model="tableParam.approvalStatusList" style="width: 150px" multiple
                                        clearable>
                                        <el-option label="审核通过" :value="1"></el-option>
                                        <el-option label="审批中" :value="2"></el-option>
                                        <el-option label="审核失败" :value="3"></el-option>
                                        <el-option label="撤销" :value="4"></el-option>
                                    </el-select>
                                </span>
                                <el-button icon="el-icon-search" style="margin-left: 24px" size="medium" class="bottom_all"
                                    @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                            </div>
                        </div>
                    </el-collapse-transition>
                    <div class="hr"></div>
                    <div class="card">
                        <div class="card_nav">
                            <div>
                            </div>
                            <div>
                                <el-link :underline="false" @click="load()">
                                    <span class="el-icon--left">
                                        <i class="iconfont iconicon_button_export1"></i>
                                    </span>
                                    导出
                                </el-link>
                            </div>
                        </div>
                        <div v-loading="tableLoading" class="card_info" :style="style">
                            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
                                border stripe style="width: 100%" :height="screenHeight - 425" :data="tableData"
                                tooltip-effect="dark">
                                <template v-for="(item, index2) in table">
                                    <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                                        :width="item.width" :fixed="item.fixed">
                                        <template slot-scope="scope">
                                            <span v-if="item.label == '状态'">
                                                <el-link v-if="scope.row.controlType == 0" type="sucess" :underline="false"
                                                    @click="applyRemoveControl(scope.row, 1)">已解控</el-link>
                                                <el-link v-if="scope.row.controlType == 1" type="sucess" :underline="false"
                                                    @click="applyRemoveControl(scope.row, 1)">已风控</el-link>
                                                <el-link v-if="scope.row.controlType == 2" type="sucess" :underline="false"
                                                    @click="applyRemoveControl(scope.row, 1)">临时解控</el-link>
                                            </span>
                                            <span v-else-if="item.label == '欠款管控等级'">
                                                <span v-if="scope.row.debtControlLevel == 0">不管控</span>
                                                <span v-if="scope.row.debtControlLevel == 1">等级一</span>
                                                <span v-if="scope.row.debtControlLevel == 2">等级二</span>
                                                <span v-if="scope.row.debtControlLevel == 3">等级三</span>
                                                <span v-if="scope.row.debtControlLevel == 4">等级四</span>
                                            </span>
                                            <span v-else-if="item.label == '审批状态'">
                                                <span v-if="scope.row.approvalStatus == 1">审核通过</span>
                                                <span v-if="scope.row.approvalStatus == 2">审批中</span>
                                                <span v-if="scope.row.approvalStatus == 3">审核失败</span>
                                                <span v-if="scope.row.approvalStatus == 4">撤销</span>
                                            </span>
                                            <span v-else-if="item.prop == 'deviationRateX'">
                                                {{ decimal.mul(scope.row.deviationRateX || 0, 100) + '%' }}
                                                <!-- {{ scope.row.deviationRateX ? scope.row.deviationRateX + '%' : '' }} -->
                                            </span>
                                            <span v-else-if="item.prop == 'latestDeviationRateX'">
                                                {{ decimal.mul(scope.row.latestDeviationRateX || 0, 100) + '%' }}
                                                <!-- {{ scope.row.latestDeviationRateX ? scope.row.latestDeviationRateX + '%' :
                                                    '' }} -->
                                            </span>
                                            <span v-else-if="item.label == '本期项目产值(万元)'">
                                                {{ decimal.div(scope.row.currentProjectOutputValue * 1 || 0, 10000) }}
                                            </span>
                                            <span v-else-if="item.label == '本期合同应收款(万元)'">
                                                {{ decimal.div(scope.row.currentContractReceivables * 1 || 0, 10000) }}
                                            </span>
                                            <span v-else-if="item.label == '本期累计回款(万元)'">
                                                {{ decimal.div(scope.row.currentCumulativePaymentReceived * 1 || 0, 10000) }}
                                            </span>
                                            <span v-else-if="item.label == '本期工程欠款(万元)'">
                                                {{ decimal.div(scope.row.currentEngineeringArrears * 1 || 0, 10000) }}
                                            </span>
                                            <span v-else-if="item.label == '本期合同欠款(万元)'">
                                                {{ decimal.div(scope.row.currentContractArrears * 1 || 0, 10000) }}
                                            </span>
                                            <span v-else-if="item.label == '上期合同应收款(万元)'">
                                                {{ decimal.div(scope.row.lastContractReceivables * 1 || 0, 10000) }}
                                            </span>
                                            <span v-else-if="item.label == '实时累计回款(万元)'">
                                                {{ decimal.div(scope.row.realTimeCumulativeReal * 1 || 0, 10000) }}
                                            </span>
                                            <span v-else-if="item.label == '操作'">
                                                <el-link v-if="scope.row.whetherLast == 1" type="danger" :underline="false"
                                                    @click="applyRemoveControl(scope.row, 2)">申请解控</el-link>
                                            </span>
                                            <span v-else>{{ scope.row[item.prop] }}</span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </div>
                    </div>
                </div>
            </el-main>
            <div class="card_bottom">
                <div class="card_bottom_left">
                    <div class="top_page_totle">总共{{ total }}条</div>
                    <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
                        :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper"
                        :total="total" @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
                </div>
                <div>
                    <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
                        @click="gettableData">刷新</el-button>
                </div>
            </div>
            <!-- 申请解控 -->
            <el-dialog :visible.sync="removeControlDig" width="1140px" :close-on-click-modal="false">
                <span slot="title" class="dialog-title">申请解控</span>
                <el-descriptions v-if="historyType != 1" :column="3" border class="descriptions" label-width="200">
                    <el-descriptions-item label="日期：" :span="3">{{ formData.dataMouth }}</el-descriptions-item>
                    <el-descriptions-item label="工程名称：" :span="3">{{ formData.engineeringName }}</el-descriptions-item>
                    <el-descriptions-item label="财务编码：">{{ formData.financialCode }}</el-descriptions-item>
                    <el-descriptions-item label="合同单位：">{{ formData.contractUnit }}</el-descriptions-item>
                    <el-descriptions-item label="施工进度：">{{ formData.constructionProgress }}</el-descriptions-item>
                    <el-descriptions-item label="本期项目产值(万元)：">{{ decimal.div(formData.currentProjectOutputValue * 1 || 0,
                        10000) }}</el-descriptions-item>
                    <el-descriptions-item label="本期合同应收款(万元)：">{{ decimal.div(formData.currentContractReceivables * 1 || 0,
                        10000) }}</el-descriptions-item>
                    <el-descriptions-item label="本期累计回款(万元)：">{{ decimal.div(formData.currentCumulativePaymentReceived * 1 ||
                        0, 10000)
                    }}</el-descriptions-item>
                    <el-descriptions-item label="本期工程欠款(万元)：">{{ decimal.div(formData.currentEngineeringArrears * 1 || 0,
                        10000) }}</el-descriptions-item>
                    <el-descriptions-item label="本期合同欠款(万元)：">{{ decimal.div(formData.currentContractArrears * 1 || 0, 10000)
                    }}</el-descriptions-item>
                    <el-descriptions-item label="剩余量：">{{ formData.remainingQuantity }}</el-descriptions-item>
                    <el-descriptions-item label="是否联营项目：">{{ formData.whetherJointVentureProject == 0 ? '否' :
                        '是' }}</el-descriptions-item>
                    <el-descriptions-item label="合同支付约定：" contentClassName="textClass2">
                        <el-input v-model="formData.contractPaymentAgreement" placeholder="请输入" type="textarea"
                            autosize></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="最近一次付款时间：">{{ formData.lastPaymentTime }}</el-descriptions-item>
                    <el-descriptions-item label="合同关于停供如何约定：" label-width="400" :span="2">
                        <el-input v-model="formData.suspensionAgreement" placeholder="请输入" type="textarea"
                            autosize></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="我司是否发函：">{{ formData.whetherSendLetter == 0 ? '否' :
                        '是' }}</el-descriptions-item>
                    <el-descriptions-item label="其他需要说明的事项：" :span="3">
                        <el-input v-model="formData.otherExplanatoryMatters" placeholder="请输入" type="textarea"
                            autosize></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="上期合同应收款(万元)：">{{ decimal.div(formData.lastContractReceivables * 1 || 0,
                        10000) }}</el-descriptions-item>
                    <el-descriptions-item label="实时累计回款(万元)（实时查询）：" labelClassName="redFont">{{
                        decimal.div(formData.realTimeCumulativeReal * 1 || 0, 10000)
                    }}</el-descriptions-item>
                    <el-descriptions-item label="偏差率（%）X：">{{ decimal.mul(formData.latestDeviationRateX || 0, 100)
                    }}</el-descriptions-item>
                    <el-descriptions-item label="合同欠款绝对额Y：">{{ formData.latestContractArrearsAbsValue
                    }}</el-descriptions-item>
                    <el-descriptions-item label="备注：" :span="3">
                        <el-input v-model="formData.applyRemark" placeholder="请输入" type="textarea" resize="none"
                            rows="1"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="附件：" :span="3">
                        <FileComponent fileCode="settlementFile" :disabled="isLook" :files="files" @deleteFile="deleteFile"
                            @uplodeSuccess="uplodeSuccess" />
                    </el-descriptions-item>
                    <el-descriptions-item label="合同文本：" :span="3">
                        <FileComponent fileCode="settlementFile" :disabled="true" :files="files3" />
                    </el-descriptions-item>

                </el-descriptions>
                <el-descriptions v-if="historyType != 1" :column="3" border class="descriptions" label-width="200"
                    style="margin-bottom: 24px;">
                    <el-descriptions-item label="供应截止时间：" labelClassName="redFont">
                        <el-date-picker v-model="formData.controlDeadlineTime" style="width: 150px;" type="date"
                            unlink-panels value-format="yyyy-MM-dd"></el-date-picker>
                    </el-descriptions-item>
                    <el-descriptions-item label="本次限量：" labelClassName="redFont">
                        <el-input v-model="formData.controlQuantity" type="number" placeholder="请输入" style="width: 150px;">
                        </el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="分部措施：" labelClassName="redFont" contentClassName="textClass">
                        <el-input v-model="formData.distributionMeasures" placeholder="请输入" type="textarea"
                            style="width: 430px;">
                        </el-input>
                    </el-descriptions-item>
                </el-descriptions>
                <span style="font-size: 18px">历史申请流程</span>
                <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                    style="width: 100%;margin-top: 12px;" tooltip-effect="dark
        " :data="formData.debtSupplyDetailHistoryList">
                    <el-table-column label="申请时间" align="center" prop="createTime" width="160"></el-table-column>
                    <el-table-column label="申请人" align="center" prop="createUserName" width="70"></el-table-column>
                    <el-table-column label="偏差率" align="center" prop="deviationRateX" width="70">
                        <template slot-scope="scope">
                            {{ decimal.mul(scope.row.deviationRateX || 0, 100) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="合同欠款绝对额" align="center" prop="contractArrearsAbsValue"
                        width="100"></el-table-column>
                    <el-table-column label="分部措施" align="center" prop="distributionMeasures" width="auto"></el-table-column>
                    <el-table-column label="本次限量" align="center" prop="controlQuantity" width="100"></el-table-column>
                    <el-table-column label="管控时间" align="center" prop="controlDeadlineTime" width="90"></el-table-column>
                    <el-table-column label="流程完成时间" align="center" prop="updateTime" width="160"></el-table-column>
                    <el-table-column label="审批状态" align="center" prop="approvalStatus" width="160">
                        <template slot-scope="scope">
                           <span v-if="scope.row.approvalStatus == 0">待提交审核</span>
                           <span v-if="scope.row.approvalStatus == 1">审核通过</span>
                           <span v-if="scope.row.approvalStatus == 2">审批中</span>
                           <span v-if="scope.row.approvalStatus == 3">审核失败</span>
                           <span v-if="scope.row.approvalStatus == 4">撤销</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="left" width="90">
                        <template slot-scope="scope">
                            <el-button size="mini" class="bottom_two" @click="lookDetail(scope.row)">
                                查看
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button class="bottom_all_two" @click="removeControlDig = false">关 闭</el-button>
                    <el-button v-if="historyType != 1" class="bottom_all" @click="saveRemoveControl">提 交</el-button>
                </span>
            </el-dialog>
            <!-- 历史记录明细 -->
            <el-dialog :visible.sync="historyDetailDig" width="1080px" :close-on-click-modal="false">
                <span slot="title" class="dialog-title">申请解控</span>
                <el-descriptions :column="3" border class="descriptions" label-width="200">
                    <el-descriptions-item label="日期：" :span="3">{{ historyDetailForm.dataMouth }}</el-descriptions-item>
                    <el-descriptions-item label="工程名称：" :span="3">{{ historyDetailForm.engineeringName
                    }}</el-descriptions-item>
                    <el-descriptions-item label="财务编码：">{{ historyDetailForm.financialCode }}</el-descriptions-item>
                    <el-descriptions-item label="合同单位：">{{ historyDetailForm.contractUnit }}</el-descriptions-item>
                    <el-descriptions-item label="施工进度：">{{ historyDetailForm.constructionProgress }}</el-descriptions-item>
                    <el-descriptions-item label="本期项目产值(万元)：">{{ decimal.div(historyDetailForm.currentProjectOutputValue * 1
                        || 0, 10000)
                    }}</el-descriptions-item>
                    <el-descriptions-item label="本期合同应收款(万元)：">{{ decimal.div(historyDetailForm.currentContractReceivables * 1
                        || 0, 10000)
                    }}</el-descriptions-item>
                    <el-descriptions-item label="本期累计回款(万元)：">{{
                        decimal.div(historyDetailForm.currentCumulativePaymentReceived * 1 || 0, 10000)
                    }}</el-descriptions-item>
                    <el-descriptions-item label="本期工程欠款(万元)：">{{ decimal.div(historyDetailForm.currentEngineeringArrears * 1
                        || 0, 10000)
                    }}</el-descriptions-item>
                    <el-descriptions-item label="本期合同欠款(万元)：">{{ decimal.div(historyDetailForm.currentContractArrears * 1 ||
                        0, 10000)
                    }}</el-descriptions-item>
                    <el-descriptions-item label="剩余量：">{{ historyDetailForm.remainingQuantity }}</el-descriptions-item>
                    <el-descriptions-item label="是否联营项目：">{{ historyDetailForm.whetherJointVentureProject == 0 ? '否' :
                        '是' }}</el-descriptions-item>
                    <el-descriptions-item label="合同支付约定：" contentClassName="textClass2">{{
                        historyDetailForm.contractPaymentAgreement }}
                    </el-descriptions-item>
                    <el-descriptions-item label="最近一次付款时间：">{{ historyDetailForm.lastPaymentTime }}</el-descriptions-item>
                    <el-descriptions-item label="合同关于停供如何约定：" label-width="400" :span="2">{{
                        historyDetailForm.suspensionAgreement }}
                    </el-descriptions-item>
                    <el-descriptions-item label="我司是否发函：">{{ historyDetailForm.whetherSendLetter == 0 ? '否' :
                        '是' }}</el-descriptions-item>
                    <el-descriptions-item label="其他需要说明的事项：" :span="3">{{ historyDetailForm.otherExplanatoryMatters }}
                    </el-descriptions-item>
                    <el-descriptions-item label="上期合同应收款(万元)：">{{ decimal.div(historyDetailForm.lastContractReceivables * 1 ||
                        0, 10000)
                    }}</el-descriptions-item>
                    <el-descriptions-item label="实时累计回款(万元)（实时查询）：" labelClassName="redFont">{{
                        decimal.div(historyDetailForm.realTimeCumulativeReal * 1 || 0, 10000)
                    }}</el-descriptions-item>
                    <el-descriptions-item label="偏差率（%）X：">{{ decimal.mul(historyDetailForm.deviationRateX || 0, 100)
                    }}</el-descriptions-item>
                    <el-descriptions-item label="合同欠款绝对额Y：">{{ historyDetailForm.contractArrearsAbsValue
                    }}</el-descriptions-item>
                    <el-descriptions-item label="备注：" :span="3">{{ historyDetailForm.applyRemark }}
                    </el-descriptions-item>
                    <el-descriptions-item label="附件：" :span="3">
                        <FileComponent fileCode="settlementFile" :disabled="true" :files="files2" />
                    </el-descriptions-item>
                    <el-descriptions-item label="合同文本：" :span="3">
                        <FileComponent fileCode="settlementFile" :disabled="true" :files="files4" />
                    </el-descriptions-item>

                </el-descriptions>
                <el-descriptions :column="3" border class="descriptions" label-width="200" style="margin-bottom: 24px;">
                    <el-descriptions-item label="供应截止时间：" labelClassName="redFont">{{ historyDetailForm.controlDeadlineTime
                    }}
                    </el-descriptions-item>
                    <el-descriptions-item label="本次限量：" labelClassName="redFont">{{ historyDetailForm.controlQuantity }}
                    </el-descriptions-item>
                    <el-descriptions-item label="分部措施：" labelClassName="redFont" contentClassName="textClass">{{
                        historyDetailForm.distributionMeasures
                    }}
                    </el-descriptions-item>
                </el-descriptions>
                <span style="font-size: 18px">领导审批参数</span>
                <el-descriptions :column="3" border class="descriptions" label-width="200" style="margin-bottom: 24px;">
                    <el-descriptions-item label="供应截止时间：" labelClassName="redFont">{{
                        historyDetailForm.approvalControlDeadlineTime }}
                    </el-descriptions-item>
                    <el-descriptions-item label="本次限量：" labelClassName="redFont">
                        {{ historyDetailForm.approvalControlQuantity }}
                    </el-descriptions-item>
                    <el-descriptions-item label="分部措施：" labelClassName="redFont" contentClassName="textClass">
                        {{ historyDetailForm.approvalDistributionMeasures }}
                    </el-descriptions-item>
                </el-descriptions>
                <FlowsNodeList :tableData="approveTableData" />
                <span slot="footer" class="dialog-footer">
                    <el-button class="bottom_all_two" @click="historyDetailDig = false">关 闭</el-button>
                </span>
            </el-dialog>
        </el-container>
    </div>
</template>
  
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { debtSupplyQueryPage, queryNewDetail, queryHistoryList, debtSupplyDetailDownload as Download, updateDetatil } from "@/api/internetSales/supplyManagement.js";
import FileComponent from "@/views/platform/ICPS/internetSales/components/fileComponent";
import FlowsNodeList from '@/components/WorkFlow/flowsNodeList';
import { getNodeList } from '@/api/task/flows';
import { getUserInfo } from "@/utils/auth.js";
export default {
    components: {
        FileComponent,
        FlowsNodeList
    },
    mixins: [mixin],
    data() {
        return {
            table: [
                { label: "日期", prop: "dataMouth", status: true, width: "70", fixed: "left", },
                { label: "财务编码", prop: "financialCode", status: true, width: "180", fixed: "left", },
                { label: "工程名称", prop: "engineeringName", status: true, width: "280", fixed: "left", },
                { label: "销售员", prop: "saller", status: true, width: "100", },
                { label: "合同单位", prop: "contractUnit", status: true, width: "220" },
                { label: "施工进度", prop: "constructionProgress", status: true, width: "auto" },
                { label: "本期项目产值(万元)", prop: "currentProjectOutputValue", status: true, width: "100" },
                { label: "本期合同应收款(万元)", prop: "currentContractReceivables", status: true, width: "110" },
                { label: "本期累计回款(万元)", prop: "currentCumulativePaymentReceived", status: true, width: "100" },
                { label: "本期工程欠款(万元)", prop: "currentEngineeringArrears", status: true, width: "100" },
                { label: "本期合同欠款(万元)", prop: "currentContractArrears", status: true, width: "100" },
                { label: "上期合同应收款(万元)", prop: "lastContractReceivables", status: true, width: "100" },
                { label: "偏差率X（%）", prop: "deviationRateX", status: true, width: "auto" },
                { label: "合同欠款绝对额Y", prop: "contractArrearsAbsValue", status: true, width: "auto" },
                { label: "实时累计回款(万元)", prop: "realTimeCumulativeReal", status: true, width: "100" },
                { label: "偏差率X（%）", prop: "latestDeviationRateX", status: true, width: "auto" },
                { label: "合同欠款绝对额Y", prop: "latestContractArrearsAbsValue", status: true, width: "auto" },
                { label: "分部措施", prop: "distributionMeasures", status: true, width: "300" },
                { label: "本次限量", prop: "controlQuantity", status: true, width: "auto" },
                { label: "管控时间", prop: "controlDeadlineTime", status: true, width: "90" },
                { label: "已用额度", prop: "usedCreditLimit", status: true, width: "90" },
                { label: "欠款管控等级", prop: "debtControlLevel", status: true, width: "auto" },
                { label: "状态", prop: "controlType", status: true, width: "auto" },
                { label: "审批状态", prop: "approvalStatus", status: true, width: "auto" },
                { label: "审批时间", prop: "controlStartTime", status: true, width: "90" },
                { label: "操作", prop: "whetherControl", status: true, width: "auto" },
            ],
            // queryPage: queryPage,
            DownloadURL: Download,
            tableData: [],
            pagesType: 0,
            tableParam: {
                page: 1,
                pageSize: 10,
                engineeringName: "",
                dataMouth: "",
                saller: "",
                debtControlLevelList: [],
                controlTypeList: [],
                approvalStatusList: [],
            },
            formData: {},
            historyDetailForm: {},
            files: [],
            files2: [],
            files3: [],
            files4: [],
            removeControlDig: false,
            historyDetailDig: false,
            low: {},
            historyType: "",
            approveTableData: [],
            userRealName: "",
        };
    },
    watch: {
    },
    async created() {
        this.tableParam.saller = await getUserInfo().userRealName;
        this.gettableData(true);
    },
    methods: {
        lookDetail(row) {
            console.log(row)
            this.historyDetailForm = row
            this.files2 = this.historyDetailForm.attachment ? JSON.parse(this.historyDetailForm.attachment) : []
            this.files4 = this.historyDetailForm.contractText ? JSON.parse(this.historyDetailForm.contractText) : []
            // 获取所有节点
            let params = {
                processManagerId: row.processManagerId,
                processTaskId: row.processTaskId,
                processVersionId: row.processVersionId
            }
            getNodeList(params).then(res => {
                if (res.code === 1001) {
                    const newData = [];
                    res.data.forEach(item => {
                        const data = {
                            nodeName: item.nodeName,
                            userName: item.instanceLogsList.map(sItem => sItem.userName),
                            userId: item.instanceLogsList.map(sItem => sItem.userId),
                            multiApprovalType: item.multiApprovalType,
                            approvalOptions: item.instanceLogsList.map(sItem => sItem.approvalOptions),
                            handlerTime: item.instanceLogsList.map(sItem => sItem.handlerTime),
                            id: item.id,
                            approvalStatus: item.approvalStatus,
                            processInstanceId: item.processInstanceId,
                            processInstanceNodeId: item.instanceLogsList.map(sItem => sItem.processInstanceNodeId),
                        }
                        newData.push(data);
                    });
                    this.approveTableData = newData;

                }
            });
            this.historyDetailDig = true
        },
        saveRemoveControl() {
            this.formData.approvalDistributionMeasures = this.formData.distributionMeasures
            this.formData.approvalControlQuantity = this.formData.controlQuantity
            this.formData.approvalControlDeadlineTime = this.formData.controlDeadlineTime
            this.formData['debtControlLevelOld'] = this.low.debtControlLevel
            this.$router.push({
                name: "debtSupplyDetailApproval",
                query: {
                    formData: JSON.stringify(this.formData),
                    dataContent: JSON.stringify(this.formData),
                    type: 1,
                }
            })
        },
        uplodeSuccess(data) {
            const params = {
                fileName: data.fileName,
                filePath: data.fileUrl,
            };
            this.files.push(params);
        },
        deleteFile(index) {
            this.files.splice(index, 1);
        },
        gettableData() {
            debtSupplyQueryPage(this.tableParam).then(res => {
                if (res.code == 1001) {
                    this.total = res.data.totalRows
                    this.tableData = res.data.data
                    //第一次进入页面获取最近一个月的数据 回显筛选
                    if (!this.tableParam.dataMouth) {
                        this.tableParam.dataMouth = res.data.data[0].dataMouth
                    }
                }
            })
        },
        //type 为1 只展示历史
        applyRemoveControl(row, type) {
            if (row.controlType == 0 && type == 2) {
                this.$message.warning('不需要重复解控!')
                return
            }
            // if (row.controlType == 2 && type == 2) {
            //     this.$message.warning('无需重复申请!')
            //     return
            // }
            this.historyType = type
            if (type == 1) {
                queryHistoryList({ id: row.id }).then(res => {
                    if (res.code == 1001) {
                        this.formData = JSON.parse(JSON.stringify(row))
                        this.low = JSON.parse(JSON.stringify(row))
                        this.formData['debtSupplyDetailHistoryList'] = res.data.debtSupplyDetailHistoryList
                        this.removeControlDig = true
                    }
                })
            } else {
                queryNewDetail({ id: row.id }).then(res => {
                    if (res.code == 1001) {
                        this.formData = JSON.parse(JSON.stringify(row))
                        this.low = JSON.parse(JSON.stringify(row))
                        this.formData['realTimeCumulativeReal'] = res.data.realTimeCumulativeReal
                        this.formData['latestDeviationRateX'] = res.data.latestDeviationRateX
                        this.formData['latestContractArrearsAbsValue'] = res.data.latestContractArrearsAbsValue
                        this.formData['remainingQuantity'] = res.data.remainingQuantity
                        this.formData['contractText'] = res.data.contractText
                        this.formData['debtControlLevel'] = res.data.debtControlLevel
                        this.formData['debtSupplyDetailHistoryList'] = res.data.debtSupplyDetailHistoryList
                        this.files = this.formData.attachment ? JSON.parse(this.formData.attachment) : []
                        this.files = this.formData.contractText ? JSON.parse(this.formData.contractText) : []
                        console.log(this.formData)
                        this.removeControlDig = true
                        updateDetatil({ id: row.id })
                    }
                })
            }


        },
        sizeChange(value) {
            this.tableParam.pageSize = value;
            this.gettableData();
        },
        /*重置数据,此方法必须存在，并且方发只重置条件*/
        init() {
            this.tableParam = this.$options.data().tableParam
            this.gettableData();
        },
    },
};
</script>
  
<style lang="scss" scoped>
.el-input,
.el-select {
    width: 240px;
}

.table_link {
    margin: 0 10px;
    color: $bg_color;
    cursor: pointer;
}

.table_link:hover {
    opacity: 0.8;
}

.textCss {
    display: flex;
    /* 核心1：开启Flex */
    align-items: center;
    text-align: center;
    /* 核心属性 */
}
</style>
<style scoped>
.descriptions>>>.redFont {
    color: red !important;
}

.descriptions>>>.textClass {
    width: 450px;
}

.descriptions>>>.textClass2 {
    width: 300px;
}</style>
  